import React from 'react';

const ResetIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.62065 5.18748C2.86729 3.04209 5.19038 1.59961 7.85039 1.59961C11.8268 1.59961 15.0504 4.82316 15.0504 8.79961C15.0504 12.7761 11.8268 15.9996 7.85039 15.9996C3.87394 15.9996 0.650391 12.7761 0.650391 8.79961"
        stroke="#424245"
        strokeWidth="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.65078 8.8C9.65078 9.79411 8.84489 10.6 7.85078 10.6C6.85667 10.6 6.05078 9.79411 6.05078 8.8C6.05078 7.80589 6.85667 7 7.85078 7C8.84489 7 9.65078 7.80589 9.65078 8.8Z"
        fill="#424245"
        stroke="#424245"
        strokeWidth="0.900037"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.15039 5.19961H1.55039V1.59961"
        stroke="#424245"
        strokeWidth="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ResetIcon;
